import { render, staticRenderFns } from "./setting-join-weibo.vue?vue&type=template&id=0ccaba2c&"
import script from "./setting-join-weibo.vue?vue&type=script&lang=js&"
export * from "./setting-join-weibo.vue?vue&type=script&lang=js&"
import style0 from "./setting-join-weibo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports